import React from 'react';
import { Link } from 'react-router-dom';

type PropsType = {
  /** Size of the square mark in px. */
  size?: number;
  /** Show the one-line positioning statement under the wordmark. */
  withTagline?: boolean;
  /** Render for a dark background. */
  onDark?: boolean;
  className?: string;
  to?: string;
};

export const LogoMark = ({ size = 40, onDark = false }: { size?: number; onDark?: boolean }) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 56 56'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-hidden='true'
    className='flex-none'
  >
    <rect width='56' height='56' rx='14' fill={onDark ? '#FFB627' : '#FFB627'} />
    <path
      d='M41.6177 17.7867H37.9069C38.0941 17.259 38.2133 16.6803 38.2133 16.0845C38.2133 13.2588 35.9323 10.9779 33.1066 10.9779C31.3193 10.9779 29.7703 11.8971 28.8511 13.2759L28 14.4163L27.1489 13.2588C26.2297 11.8971 24.6807 10.9779 22.8934 10.9779C20.0677 10.9779 17.7867 13.2588 17.7867 16.0845C17.7867 16.6803 17.9059 17.259 18.0931 17.7867H14.3823C12.4929 17.7867 10.9949 19.3017 10.9949 21.1911L10.9779 39.9155C10.9779 41.8049 12.4929 43.3199 14.3823 43.3199H41.6177C43.5072 43.3199 45.0221 41.8049 45.0221 39.9155V21.1911C45.0221 19.3017 43.5072 17.7867 41.6177 17.7867ZM33.1066 14.3823C34.0429 14.3823 34.8089 15.1483 34.8089 16.0845C34.8089 17.0207 34.0429 17.7867 33.1066 17.7867C32.1704 17.7867 31.4044 17.0207 31.4044 16.0845C31.4044 15.1483 32.1704 14.3823 33.1066 14.3823ZM22.8934 14.3823C23.8296 14.3823 24.5956 15.1483 24.5956 16.0845C24.5956 17.0207 23.8296 17.7867 22.8934 17.7867C21.9572 17.7867 21.1912 17.0207 21.1912 16.0845C21.1912 15.1483 21.9572 14.3823 22.8934 14.3823ZM41.6177 39.9155H14.3823V36.511H41.6177V39.9155ZM41.6177 31.4044H14.3823V21.1911H23.0296L19.489 26.0084L22.2465 28L28 20.1698L33.7535 28L36.5111 26.0084L32.9705 21.1911H41.6177V31.4044Z'
      fill='#171210'
    />
  </svg>
);

export default function Logo({
  size = 40,
  withTagline = false,
  onDark = false,
  className = '',
  to = '/',
}: PropsType) {
  return (
    <Link to={to} className={`main-logo group ${className}`} aria-label='E-Gift Cards — home'>
      <LogoMark size={size} onDark={onDark} />
      <span className='logo-text'>
        <span
          className='display'
          style={{ fontSize: size * 0.46, lineHeight: 1 }}
          // eslint-disable-next-line react/no-unknown-property
        >
          <span className={onDark ? 'text-paper' : 'text-ink-900'}>E-Gift Cards</span>
        </span>
        {withTagline && (
          <span
            className={`mt-1 block text-[10px] font-medium leading-tight ${
              onDark ? 'text-ink-300' : 'text-ink-400'
            }`}
          >
            Armenia&rsquo;s first digital gift card platform
          </span>
        )}
      </span>
    </Link>
  );
}
